// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"AboutAIMessage_moreButton__MEY4r","aiSuggestions":"AboutAIMessage_aiSuggestions___19QG","hidden":"AboutAIMessage_hidden__TvfEL"};